//Needed to add below comment to keep eslint from throwing a no-useless-escape error
/* eslint no-useless-escape: "off", curly: "error" */
export const PASSWORDPATTERN = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
);
